export default __webpack_public_path__ + "static/media/cryptodetail.b65ea986.jpg";